import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ProfileMenuContainer = styled.div`
  position: relative;
`;

export const $ProfileMenuTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${spacing('xs')};
  color: ${({ theme }) => theme.colors.default};
  transition: opacity ${({ theme }) => theme.interactions.basicTiming};

  &:hover {
    opacity: 0.7;
  }
`;
